import { CanvasTexture, RepeatWrapping, SRGBColorSpace } from 'three';

/**
 * 노면에 칠하는 표식 텍스처.
 *
 * 아스팔트만 깔면 "넓은 회색 바닥"에서 "넓은 아스팔트 바닥"이 될 뿐입니다. 트랙으로
 * 읽히게 하는 것은 칠해진 선입니다. 그리고 출발선은 속도를 가늠할 기준점이 됩니다 —
 * 아무 무늬 없는 노면에서는 얼마나 빠른지 알 수 없습니다.
 */

/** 체커 한 칸의 픽셀 수. 두 칸씩 두 줄이면 32×32입니다. */
const CHECKER_CELL = 16;

/**
 * 출발·결승선 체커.
 *
 * 2×2 칸만 만들고 반복으로 늘립니다. 칸 수를 텍스처에 굽지 않으면 선 길이를 바꿀 때
 * 텍스처를 다시 만들지 않고 repeat만 조정하면 됩니다.
 *
 * @returns 2D 컨텍스트가 없는 환경(jsdom)에서는 null.
 */
export function createStartLineTexture(): CanvasTexture | null {
  const canvas = document.createElement('canvas');
  canvas.width = CHECKER_CELL * 2;
  canvas.height = CHECKER_CELL * 2;
  const context = canvas.getContext('2d');
  if (context === null) {
    return null;
  }

  /*
   * 순백(#fff)과 순흑(#000)을 피합니다. 밝은 HDRI 배경에서 순백은 톤 매핑에 걸려
   * 번지고, 순흑은 노면보다 어두워서 구멍처럼 보입니다.
   */
  const light = '#e8e8ea';
  const dark = '#1b1c1f';
  context.fillStyle = light;
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = dark;
  context.fillRect(0, 0, CHECKER_CELL, CHECKER_CELL);
  context.fillRect(CHECKER_CELL, CHECKER_CELL, CHECKER_CELL, CHECKER_CELL);

  const texture = new CanvasTexture(canvas);
  texture.colorSpace = SRGBColorSpace;
  texture.wrapS = RepeatWrapping;
  texture.wrapT = RepeatWrapping;
  return texture;
}
